// extracted by mini-css-extract-plugin
export default {"noOutline":"_2sIhp"};